import { render, staticRenderFns } from "./PlatformsGraph.vue?vue&type=template&id=10919ae4"
import script from "./PlatformsGraph.vue?vue&type=script&lang=js"
export * from "./PlatformsGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports